import { ProposalStatusCode } from '@pulseops/business/core'
import * as t from 'io-ts'
import { form2 } from '@pulseops/common'

export namespace IssueForm {
  export const codec = t.type({
    proposalStatus: form2.stringEnum(ProposalStatusCode).required
  })
}
